import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import auth from './modules/auth'
import account from './modules/account'
import language from './modules/language'
import transfer from './modules/transfer'
import setting from './modules/setting'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['auth', 'account', 'language', 'setting']
})

// export default new Vuex.Store({
const store = new Vuex.Store({
  state: {
    drawer: false,
    loading: false
  },
  mutations: {
    TOGGLE_DRAWER: state => (state.drawer = !state.drawer),
    SET_DRAWER: (state, value) => (state.drawer = value),
    SET_LOADING: (state, value) => (state.loading = value)
  },
  actions: {
    toggleDrawer({ commit }) {
      commit('TOGGLE_DRAWER')
    },
    setDrawer({ commit }, payload) {
      commit('SET_DRAWER', payload)
    },
    setLoading({ commit }, payload) {
      commit('SET_LOADING', payload)
    }
  },
  modules: {
    auth,
    account,
    language,
    transfer,
    setting
  },
  plugins: [vuexLocal.plugin]
})

Vue.prototype.$store = store

export default store
